<template>
    <div>
        <navigation-item v-if="showPrevious" direction="backwards" @click="onClick"></navigation-item>
        <div v-if="directions">
            <direction-item
                v-for="(direction, index) in directions"
                :key="index"
                :html="direction.html_instructions"
                :distance="direction.distance.text"
                :icon="icon"
            >
            </direction-item>
        </div>
        <div v-else>
            <stage-item :step="step" :icon="icon"></stage-item>
        </div>
        <navigation-item v-if="showNext" direction="forward" @click="onClick"></navigation-item>
        <custom-stage-item v-if="!showNext" :time="currentJourney.return.arrival_at" title="Return home"></custom-stage-item>
    </div>
</template>
<script>
import NavigationItem from '@/components/StageDirectionsNavigationItem.vue'
import DirectionItem from '@/components/DirectionItem.vue'
import CustomStageItem from '@/components/CustomStageItem.vue'
import StageItem from '@/components/StageItem.vue'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'direction',
    props: ['step', 'showNext', 'showPrevious'],
    components: {
        NavigationItem,
        DirectionItem,
        StageItem,
        CustomStageItem,
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapState([
            'currentJourney',
        ]),
        ...mapGetters([
            'getSVGCircledIconNameByTransportMode',
        ]),
        directions() {
            return this.step ? this.step.directions : []
        },
        icon() {
            return this.getSVGCircledIconNameByTransportMode(this.step.type)
        },
    },
    methods: {
        onClick(type) {
            this.$emit('navigate', type)
        },
    },
}
</script>
